import 'reflect-metadata';
import { Container } from '@patsnap/tahiti-core/shared/inversify';
import { baseModule } from '@/container-modules/base-module';
import { headerServiceModule } from '@/container-modules/header-service-module';
import { biTrackModule } from '@eureka/domains';

const container = new Container({
    defaultScope: 'Singleton',
    skipBaseClassChecks: true,
});

container.load(
    baseModule,
    headerServiceModule,
    biTrackModule,
);

export { container };
